import { Bars3Icon } from "@heroicons/react/24/outline";
import { Link } from "react-router-dom";
import styled from "styled-components";

export const NAV_BAR_HEIGHT = 56;

const NavBarContainer = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1100;
  display: flex;
  align-items: center;
  gap: 12px;
  height: ${NAV_BAR_HEIGHT}px;
  padding: 0 14px;
  background-color: ${(props) => props.theme.navBg};
  border-bottom: 1px solid ${(props) => props.theme.border};
`;

const MenuButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: 1px solid ${(props) => props.theme.border};
  border-radius: 8px;
  background: transparent;
  color: ${(props) => props.theme.textColor};
  cursor: pointer;

  &:hover {
    background: ${(props) => props.theme.surfaceHover};
  }

  svg {
    width: 20px;
    height: 20px;
  }
`;

const BrandLink = styled(Link)`
  display: flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
  color: ${(props) => props.theme.textColor};
  font-size: 15px;
  font-weight: 650;
  letter-spacing: -0.01em;

  img {
    width: 26px;
    height: 26px;
  }
`;

// Top bar for narrow screens, where the sidebar turns into a drawer.
const NavBar: React.FC<{ onMenuClick?: () => void }> = ({ onMenuClick }) => {
  return (
    <NavBarContainer>
      <MenuButton onClick={onMenuClick} aria-label="Open menu">
        <Bars3Icon />
      </MenuButton>
      <BrandLink to="/">
        <img src={`${process.env.PUBLIC_URL}/logo-small.png`} alt="" />
        Minglify
      </BrandLink>
    </NavBarContainer>
  );
};
export default NavBar;
